<template>
  <div class="nwx-app-select">
    <div
      :class="{
        'app-select-cont': true,
        'text-background': appLogoText && !appLogoUrl,
        opened: isDropdownVisible,
        error: error,
      }"
      :style="selectContStyle"
      @click.stop="toggleDropdown()"
    >
      <span v-if="localSelected && localSelected.length > 0" class="counter">
        {{ localSelected.length }}
      </span>
      <div v-if="appLogoText && !appLogoUrl" class="app-logo-text">
        {{ appLogoText }}
      </div>
    </div>
    <div
      :class="{
        'app-select-dropdown': true,
        visible: isDropdownVisible,
        error: error,
      }"
    >
      <div v-if="items.length === 0" class="no-option-msg">Sorry, no options available</div>
      <template v-else>
        <div v-if="selectAllText" class="option-row">
          <label
            :class="{
              'checkbox-container': true,
              checked: this.isSelectAll,
            }"
            @click.stop="toggleSelectAll()"
          >
            <div class="padding-wrap">
              <div class="label-text">
                {{ selectAllText }}
              </div>
              <span class="checkmark"></span>
            </div>
          </label>
        </div>
        <div class="option-row"
          v-for="(option, index) in itemsValues"
          :class="{
            disabled: option.disabled,
          }"
          :key="index"
        >

          <!-- bundle -->

          <div class="bundle" v-if="option.type && option.type === 'bundle'">
            <label
              class="checkbox-container"
              :class="{
                checked: bundleIsChecked(option),
              }"
              :for="`checkbox-id-${uid}${option.value}`"
              @click="toggleBundleItems(option)"
            >
              <div class="padding-wrap">
                <div class="label-text">
                  <slot name="option-bundle-text" :option="option">
                    {{ option.text }}
                  </slot>
                </div>
                <span class="checkmark"></span>
              </div>
            </label>
          </div>

          <!-- other items  -->

          <label
            class="checkbox-container"
            :class="{
              checked: localSelected && localSelected.indexOf(option.value) !== -1,
            }"
            :for="`checkbox-id-${uid}${index}`"
            v-else
          >
            <div class="padding-wrap">
              <div class="label-text">
                <slot name="option-text" :option="option">
                  {{ option.text }}
                </slot>
              </div>
              <input
                type="checkbox"
                :value="option.value"
                :name="`checkbox-id-${uid}`"
                :id="`checkbox-id-${uid}${index}`"
                :disabled="option.disabled"
                v-model="localSelected"
              />
              <span class="checkmark"></span>
            </div>
          </label>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'NwxAppSelect',
    props: {
      selected: {
        type: [String, Array],
        default: undefined,
      },
      items: {
        type: Array,
        default: () => [],
      },
      appLogoUrl: String,
      appLogoText: String,
      selectAllText: String,
      error: Boolean,
    },
    model: {
      prop: 'selected',
      event: 'appselect:changed',
    },
    data() {
      return {
        // eslint-disable-next-line
        uid: this._uid,
        itemsValues: [],
        localSelected: [],
        nativeChangeEnabled: false,
        programChangeEnabled: true,
        isDropdownVisible: false,
      };
    },
    computed: {
      isSelectAll() {
        return this.localSelected && this.localSelected.length === this.itemsValues.length;
      },
      selectContStyle() {
        let result = {};

        if (this.appLogoUrl) {
          result = {
            'background-image': `url(${this.appLogoUrl})`,
          };
        }

        return result;
      },
    },
    watch: {
      selected(selected) {
        if (this.programChangeEnabled) {
          this.nativeChangeEnabled = false;
          const selectedOpt = this.getSelectedOpt(selected);
          this.localSelected = selectedOpt.value;
        }
        this.programChangeEnabled = true;
      },
      localSelected(selected) {
        const selectedOpt = this.getSelectedOpt(selected);

        if (this.nativeChangeEnabled) {
          this.programChangeEnabled = false;
          this.$emit('appselect:changed', selectedOpt.value);
          this.$emit('change');
        }
        this.nativeChangeEnabled = true;
      },
    },
    methods: {
      toggleDropdown() {
        this.isDropdownVisible = !this.isDropdownVisible;
      },
      toggleSelectAll() {
        if (this.isSelectAll) {
          this.localSelected = [];
        } else {
          this.localSelected = this.itemsValues.map((item) => item.value);
        }
      },
      getSelectedOpt(selected) {
        let itemValue = [];
        let itemText = '';

        if (Array.isArray(selected)) {
          const filtered = [];

          selected.forEach((item) => {
            const newItem = this.itemsValues.find((v) => v.value === item);
            if (newItem) {
              filtered.push(newItem);
            }
          });

          itemValue = filtered.map((item) => item.value);

          itemText = filtered.map((
            (item) => item.text
          )).join('; ');
        }

        return { value: itemValue, text: itemText };
      },
      hasChildren(option) {
        return !!option.children;
      },
      bundleIsChecked(option) {
        return this.localSelected.includes(option.value);
      },
      undisabledItems() {
        this.itemsValues = this.itemsValues.map((item) => ({ ...item, disabled: false }));
      },
      toggleBundleItems(option) {
        // if all products of bundle is check, then uncheck
        if (this.bundleIsChecked(option)) {
          this.undisabledItems();
          // uncheck products bundle
          this.localSelected = this.localSelected
            .filter((item) => !option.products.includes(item))
            .filter((item) => option.value !== item);
        } else {
          this.undisabledItems();
          const bundles = this.itemsValues
            .filter((item) => item.type && item.type === 'bundle' && item.value !== option.value)
            .map((item) => item.value);

          // uncheck exclude products
          if (option.exclude) {
            this.localSelected = this.localSelected
              .filter((item) => !option.exclude.includes(item));
          }

          option.products.forEach((product) => {
            // disable products contained bundle
            this.itemsValues = this.itemsValues.map((item) => {
              if (item.value === product) {
                return { ...item, disabled: true };
              }
              return item;
            });

            // check products bundle
            if (!this.localSelected.includes(product)) {
              this.localSelected.push(product);
            }
          });

          this.localSelected = this.localSelected
            .filter((item) => !bundles.includes(item));

          if (!this.localSelected.includes(option.value)) {
            this.localSelected.push(option.value);
          }
        }
      },
    },
    mounted() {
      this.itemsValues = this.items;

      const selectedOpt = this.getSelectedOpt(this.selected);
      this.localSelected = selectedOpt.value;

      if (this.appLogoUrl) {
        const appLogo = new Image();
        appLogo.src = this.appLogoUrl;
      }
    },
    updated() {
      this.nativeChangeEnabled = true;
      this.programChangeEnabled = true;
    },
  };
</script>

<style lang="less" scoped>
@import "../assets/variables";

.nwx-app-select {
  .app-select-cont {
    position: relative;
    height: 120px;
    cursor: pointer;
    background-color: #fff;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 4px;
    border: 1px solid @inputGray;
    transition: border-color ease-out 0.2s;

    &.text-background {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 84px;
    }

    &:hover {
      border-color: @labelGray;
    }

    &.opened {
      border-radius: 4px 4px 0 0;
      border-color: @mainBlue;
    }

    &.error {
      border-color: @mainRed;
    }

    .app-logo-text {
      font-size: 19px;
      font-weight: 600;
      color: @mainBlue;
      user-select: none;
    }

    .counter {
      color: #fff;
      background: @mainBlue;
      font-size: 11px;
      font-weight: bold;
      line-height: 1;
      text-align: center;
      padding: 5px;
      min-width: 22px;
      height: 22px;
      border-radius: 50%;
      position: absolute;
      top: 11px;
      left: 11px;
    }
  }

  .app-select-dropdown {
    display: none;
    position: relative;
    top: -1px;
    background: #fff;
    border-radius: 0 0 4px 4px;
    border: 1px solid @inputGray;

    &.visible {
      display: block;
      border-color: @mainBlue;
      border-top-color: @inputGray;
    }

    &.error {
      border-color: @mainRed;
      border-top-color: @inputGray;
    }

    .no-option-msg {
      height: 52px;
      padding: 15px 28px;
      cursor: default;
      font-size: 16px;
      user-select: none;
    }

    .option-row {
      //&:hover {
      //  background: @bodyWhite;
      //}

      & label {
        z-index: 10;
        &:hover {
          background: @bodyWhite;
        }
      }

      &:nth-last-of-type(1) {
        border-radius: 0 0 4px 4px;
      }

      & + .option-row .padding-wrap {
        border-top: 1px solid fade(@mainGray, 15%);
      }

      &.disabled {
        //background: #ebeff2;
        cursor: default;

        .checkbox-container {
          color: fade(@mainGray, 40%);

          &.checked {
            color: fade(@mainGray, 40%);

            .formerly {
              color: fade(@mainGray, 40%);
            }

            .checkmark {
              border-color: #999;
              background-color: #999;
            }
          }
        }
      }

      .checkbox-container {
        display: block;
        position: relative;
        cursor: pointer;
        width: 100%;
        margin: 0;
        padding: 0 28px;
        font-weight: 400;
        font-size: 16px;
        user-select: none;

        .padding-wrap {
          min-height: 52px;
          padding: 15px 0;
        }

        .label-text {
          padding-left: 26px;

          .formerly {
            font-size: 13px;
            color: fade(@mainGray, 70%);
          }
        }

        input {
          position: absolute;
          cursor: pointer;
          opacity: 0;
          height: 0;
          width: 0;
        }

        .checkmark {
          top: 18px;
          position: absolute;
          height: 16px;
          width: 16px;
          border: 1px solid @inputGray;
          background: #fff;
          border-radius: 2px;
          transition: background 0.2s, border 0.2s;

          &:after {
            content: " ";
            display: block;
            width: 100%;
            height: 100%;
            background: url("//img.netwrix.com/elements/partnerPortal/pipeline/checkmark.svg");
            background-repeat: no-repeat;
            background-position: center;
            opacity: 0;
          }
        }

        &.checked {
          color: @mainBlue;

          .checkmark {
            border-color: @mainBlue;
            background-color: @mainBlue;

            &:after {
              opacity: 1;
            }
          }
        }
      }

      .children {
        .padding-wrap {
          padding-left: 25px;
        }
      }
    }
  }
}
</style>
